import { Platform } from 'utils/platform';

export const isMobile = Platform.OS === 'ios' || Platform.OS === 'android';

export const isMobileOrSmallScreen = (width: number) => isMobile || width < 996;
